import { useEffect, useState } from 'react'
import { CartState } from '../Context/Context'
import "./cart.css"
import { AiFillDelete} from 'react-icons/ai';
import { motion } from "framer-motion"
import { Link } from "react-router-dom"

const Loadvariants = {
  hidden: { opacity: 0,
  },
  visible: { opacity: 1,
     transition: {
          type: "spring",
          duration: 3
     },
  }
}
const Cart = () => {

  const { state: {cart } , dispatch} = CartState()

  const [total, setTotal] = useState(0)

  useEffect(()=>{
                //setTotal(cart.reduce((acc, curr) => acc + Number(curr.price)*curr.qty , 0));

                setTotal("CheckOut Page")
  }, [cart])
  return (
    <section className='cart__section'>
        <motion.div className="cart__container"
        initial="hidden"
        animate="visible"
        variants={Loadvariants}
        exit={{
          x: "-100vw",
         transition:{ ease: 'easeInOut'}
        }}
        >
             <div className="cart__list">
                 {
                   cart.map((prod)=> (
                     <div className="cart__sublist" key={prod.id}>
                        <div className="col">
                                <img src={prod.img} alt="" />
                            </div>
                            <div className="col">
                                <span style={{fontWeight: 600}}>{prod.title}</span>
                            </div>
                            <div className="col">
                                <span>{prod.price}</span>
                            </div>
                          { /* <div className="col">
                                <form >
                                   <select value={prod.qty}className='cart__form'
                                   onChange={(e)=>
                                    dispatch({
                                      type: "CHANGE_CART_QTY",
                                      payload: {
                                        id: prod.id,
                                        qty: e.target.value,
                                      },
                                    })
                                  }
                                   >
                                     <option value="1">1</option>
                                     <option value="2">2</option>
                                     <option value="3">3</option>
                                     <option value="4">4</option>
                                     <option value="5">5</option>
                                   </select>
                                </form>
                                </div>*/}
                            <div className="col">
                            <AiFillDelete 
                                      fontSize="20px"
                                      style={{
                                        cursor: "pointer"
                                      }}
                                      onClick = {() =>dispatch({
                                        type: "REMOVE_FROM_CART",
                                        payload: prod,
                                      })}
                                   />
                            </div>
                     </div>
                   ))
                 }
             </div>
      
      <div className="cart__summary">
          <span className="summary__title">Subtotal ( {cart.length} ) items</span>
          <span style={{ fontWeight: 700, fontSize: 20 , marginBottom: 10, color: "white"}}>Total: $ {total}</span>

           <Link to="/checkout">
            <button className='summary__btn'
            disabled={cart.length === 0}
            >
              Proceed to Checkout
            </button>
            </Link>
      </div>



        </motion.div>
        
    </section>
  )
}

export default Cart;